import React, { Component } from "react";
import { Link } from "react-router-dom";

import place1 from "../images/place-1.jpg";
import place2 from "../images/place-2.jpg";
import place4 from "../images/place-4.jpg";
import place5 from "../images/place-5.jpg";
import place6 from "../images/place-6.jpg";

export default class DestinationSection extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="destination-section">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="section-title">
                  <div className="bar mx-auto">
                    <span className="inner-bar"></span>
                  </div>
                  <h3>Popular Destination</h3>
                  <p>
                    Cum doctus civibus efficiantur in imperdiet deterruisset
                  </p>
                </div>
                <div className="destinations">
                  <div className="row">
                    <div className="col-md-6">
                      <Link
                        to="/"
                        alt="Click for details"
                        className="destination-item"
                      >
                        <img src={place1} alt="Destinations" />
                        <h4>Da Alfredo</h4>
                        <div className="location">
                          <h6 className="bg-primary">Dhaka</h6>
                          <p>Lorem ipsum dolor sit amet</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-md-6">
                      <Link
                        to="/"
                        alt="Click for details"
                        className="destination-item"
                      >
                        <img src={place2} alt="Destinations" />
                        <h4>Da Alfredo</h4>
                        <div className="location">
                          <h6 className="bg-primary">Dhaka</h6>
                          <p>Lorem ipsum dolor sit amet</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-md-4">
                      <Link
                        to="/"
                        alt="Click for details"
                        className="destination-item"
                      >
                        <img src={place6} alt="Destinations" />
                        <h4>Da Alfredo</h4>
                        <div className="location">
                          <h6 className="bg-primary">Dhaka</h6>
                          <p>Lorem ipsum dolor sit amet</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-md-4">
                      <Link
                        to="/"
                        alt="Click for details"
                        className="destination-item"
                      >
                        <img src={place4} alt="Destinations" />
                        <h4>Da Alfredo</h4>
                        <div className="location">
                          <h6 className="bg-primary">Dhaka</h6>
                          <p>Lorem ipsum dolor sit amet</p>
                        </div>
                      </Link>
                    </div>
                    <div className="col-md-4">
                      <Link
                        to="/"
                        alt="Click for details"
                        className="destination-item"
                      >
                        <img src={place5} alt="Destinations" />
                        <h4>Da Alfredo</h4>
                        <div className="location">
                          <h6 className="bg-primary">Dhaka</h6>
                          <p>Lorem ipsum dolor sit amet</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
